import React from 'react';

import MyStore from '../../../MyStore';

export default function DeliveryParamsWeb({ handler }) {
  return <MyStore isOnboarding handler={handler}  />
}